/** @jsx jsx */
import React, { CSSProperties } from 'react'
import { css, jsx } from '@emotion/react'
import { FacilityAvailableStatusCode } from '../entites/FacilityInfo'
import { CongestionCircleSvg } from './status_circle_svg/CongestionCircleSvg'
import { FullCircleSvg } from './status_circle_svg/FullCircleSvg'
import { NotContractedCircleSvg } from './status_circle_svg/NotContractedCircleSvg'
import { VacanciesCircleSvg } from './status_circle_svg/VacanciesCircleSvg'

export type CircleStatusIconProps = {
  statusCode: FacilityAvailableStatusCode
  style?: CSSProperties
  size?: 'sm' | 'semismall' | 'md'
}

export const CircleStatusIcon = ({
  statusCode,
  style,
  size = 'md',
}: CircleStatusIconProps) => {
  let SvgComponent
  switch (statusCode) {
    case 'before_acceptance':
    case 'end_acceptance':
    case 'holiday':
      SvgComponent = null
      break
    case 'vacancies':
      SvgComponent = VacanciesCircleSvg
      break
    case 'vacancies_little':
      SvgComponent = CongestionCircleSvg
      break
    case 'congestion':
    case 'full':
      SvgComponent = FullCircleSvg
      break

    default:
      SvgComponent = NotContractedCircleSvg
      break
  }

  if (!SvgComponent) return null
  return (
    <span css={iconStyle} style={style}>
      <SvgComponent size={size} />
    </span>
  )
}

const iconStyle = css`
  display: inline-flex;
`
